import styles from './spinner.scss?inline';
import { LitElement, html, unsafeCSS, CSSResult } from 'lit';
import { property } from 'lit/decorators.js';

// TODO: replace these numbers (SpinnerDiameter, SpinnerStrokeWidth) with token values
export type SpinnerDiameter = 128 | 48 | 16;
export type SpinnerStrokeWidth = 2 | 4;
export type SpinnerSize = 'small' | 'medium' | 'large';

export class SpinnerComponent extends LitElement {
  
  static selector = `{{c11n-prefix}}-spinner`;
  static override styles: CSSResult = unsafeCSS(styles);
  static define = () => {
    const isDeclared = customElements.get(SpinnerComponent.selector);
    if (!isDeclared) {
      customElements.define(SpinnerComponent.selector, SpinnerComponent);
    }
  }

  strokeWidth: SpinnerStrokeWidth = 4;
  diameter: SpinnerDiameter = 48;
  radius!: number;

  // Some attributes (size) were being stripped in Stencil apps,
  // but we found a simple workaround. If using @property 
  // we may need to differentiate the name from the attribute 
  // https://github.com/ionic-team/stencil/issues/2703

  @property({ attribute: 'size', type: String })
  _size: SpinnerSize = 'medium';

  @property({ attribute: 'spinner-status', type: String })
  spinnerStatus: string = 'Loading...';

  @property({ attribute: 'c11n-web-spinner', type: Boolean, reflect: true })
  readonly _c11n_web_spinner: boolean = true;

  getDiameter(): SpinnerDiameter {
    if (this._size === 'large') {
      return 128;
    }
    if (this._size === 'small') {
      return 16;
    }
    return 48;
  }

  getStrokeWidth(): SpinnerStrokeWidth {
    if (this._size === 'small') {
      return 2;
    }
    return 4;
  }

  override connectedCallback(): void {
    super.connectedCallback();
  }

  override render() {
    this.diameter = this.getDiameter();
    this.strokeWidth = this.getStrokeWidth();
    this.radius = (this.diameter - this.strokeWidth) / 2;
    return html`
      <p class="c11n-spinner__status" role="alert" aria-live="assertive">${ this.spinnerStatus }</p>
      <svg viewBox="0 0 ${ this.diameter } ${ this.diameter }" xmlns="http://www.w3.org/2000/svg">
        <circle cx="${ this.diameter / 2 }" cy="${ this.diameter / 2 }" r="${ this.radius }" />
        <circle cx="${ this.diameter / 2 }" cy="${ this.diameter / 2 }" r="${ this.radius }" />
      </svg>
    `;
  }
}

export const C11nSpinner = SpinnerComponent.selector;
